const getQuerystring = () => {
  const queries = {};
  const queryString = decodeURIComponent(window.location.search.substring(1));
  const vars = queryString.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    queries[pair[0].toLowerCase()] = pair[1];
  }
  return queries;
};

export default getQuerystring;



// WEBPACK FOOTER //
// ./src/scripts/utils.js